export enum IntervalEnum {
  MONTH = "month",
  YEAR = "year",
}
